export enum UploadLogoEnum {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
}
export type UploadLogoResponse = Record<UploadLogoEnum, string>
